import React,{useState, useEffect, useContext} from "react";
import Global from '../../APIConfig';
import { useNavigate,Link } from "react-router-dom";
import AuthUser from "../../AuthUser";
import axios from 'axios';
import { AppContext } from '../../context/AppContext';

function CodLeftPanel()
{
    let navigate = useNavigate();
    const{headers1,headers2,logout}=AuthUser();
    const[show,SetShow]=useState('close');
    const items = JSON.parse(localStorage.getItem('user'));
    const user_privilage_string = items.user_privilage_array;
    const user_privilage_array = user_privilage_string.split(',').map(Number);
    // const [companyname, setCompanyname] = useState('Consolidix Logistics');
    const [loading, setloading] = useState(false);
    const [DropdownType, setDropdownType] = useState('');
    const { companyname } = useContext(AppContext);
    
    const userlogout=()=>{
      logout();
      navigate('/');
    }
    return (
        <div className={`sidebar ${show}`}>
          <div className="logo-details">
            <div className="head_icon" onClick={()=>{SetShow(show=='close'?'show':'close')}}>
                <i className="bx bx-menu"></i>
            </div>
            <span className="logo_name">{companyname}</span>
          </div>
          <ul className="nav-links">
          <li className={DropdownType=='dashboard'?`showMenu`:''}>
              <div className="iocn-link">
                <a href="#" onClick={()=>{DropdownType!='dashboard'?setDropdownType('dashboard'):setDropdownType('')}}>
                  <i className="bx bx-grid-alt"></i>
                  <span className="link_name">Dashboard</span>
                </a>
                <i className="bx bxs-chevron-down arrow"></i>
              </div>
              <ul className="sub-menu">
                <li><a className="link_name" href="#">Dashboard</a></li>
                <li><a href="/Admin-Dash">Master Dashboard</a></li>
              </ul>
            </li>
            
                <li>
                    <div className="iocn-link" bis_skin_checked="1">
                        <a href="#">
                        <i className="bx bx-receipt"></i>
                        <span className="link_name">COD Collection</span>
                        </a>
                        <i className="bx bxs-chevron-down arrow"></i>
                    </div>
                    <ul className="sub-menu">
                        <li><a className="link_name" href="#">COD Collection</a></li>
                        <li><a href="/DriverCOD">Driver COD Collection</a></li>
                        {items.usertype =='AD' &&
                        <li><a href="/HubCOD">Hub COD Collection</a></li>
                        }
                    </ul>
                </li>
                <li>
                    <div className="iocn-link" bis_skin_checked="1">
                        <a href="#">
                        <i className="bx bx-receipt"></i>
                        <span className="link_name">COD Reports</span>
                        </a>
                        <i className="bx bxs-chevron-down arrow"></i>
                    </div>
                    <ul className="sub-menu">
                        <li><a className="link_name" href="#">COD Payment Reports</a></li>
                        <li><a href="/DriverCodOverview">Driver COD Overview</a></li>
                        {items.usertype =='AD' &&
                        <li><a href="/HubCodOverview">Hub COD Overview</a></li>
                        }
                    </ul>
                </li>
                
            <li>
            <div className="profile-details">
                <div className="profile-content">
                <img src={`${Global.logoUrl}${items.profile_image}`} alt="profileImg" />
                </div>
                <div className="name-job">
                <div className="profile_name">{items.name}</div>
                <div className="job">{items.company}</div>
                </div>
                <i className="bx bx-log-out" onClick={()=>userlogout()}></i>
            </div>
            </li>
      </ul>
    </div>
    );

}
export default CodLeftPanel;